// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}
export var passiveOption = supportsPassive ? { passive: true } : false;


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/passiveOption.js
// module id = 487
// module chunks = 2